module.exports = __webpack_public_path__ + "img/line-2-3.svg";